import { combineReducers } from "redux";
import { storeSelf } from "@fdn/profile_store";
import storeReview from "../Review/lib/store";
import storeHighlightReview from "../HightlightReview/lib/store";
import storeSearchProducts from "../SearchProducts/lib/store";
import storeSearchServices from "../SearchServices/lib/store";
import storeSearchBrands from "../SearchBrands/lib/store";
import storeSearchBrandService from "../searchBrandService/lib/store";
import storeSearchUsers from "../SearchUsers/lib/store";
import storeSearchArticles from "../SearchArticles/lib/store";
import storeCategory from "../ProductCategory/lib/store";
import storeBrandList from "../BrandList/lib/store";
import storeCompleting from "../completing/lib/store";
import storeWallet from "../AlloWallet/lib/store";
import storePoint from "../AlloPoint/lib/store";
import storeProductMatches from "../ProductMatches/lib/store";
import storeTopMembers from "../TopMembers/lib/store";
import storeSearchDefault from "../SearchDefault/lib/store";
import storeQuickSearch from "../QuickSearch/lib/store";
import storeSearchResult from "../SearchResult/lib/store";
import storeListCategory from "../category/lib/store";

const rootReducer = combineReducers({

	storeSelf,
	storeReview,
	storeHighlightReview,
	storeSearchProducts,
	storeSearchServices,
	storeSearchBrands,
	storeSearchBrandService,
	storeSearchUsers,
	storeSearchArticles,
	storeBrandList,
	storeCompleting,
	storeWallet,
	storeProductMatches,
	storeTopMembers,
	storePoint,
	storeSearchDefault,
	storeQuickSearch,
	storeSearchResult,
	storeCategory,
	storeListCategory,
});

export default rootReducer;
